import { SVGProps } from 'react';

export const PlusIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='12'
      height='13'
      viewBox='0 0 12 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path d='M6 2.75V10.25M9.75 6.5L2.25 6.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};
